import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useSelector } from 'react-redux';
import Alert from '../Alert/Alert';
import ResetPwForm from '../LoginForm/ResetPwForm';

const PasswordEditForm = ({ setAllEditing, isEditingPw, setIsEditingPw }) => {
    const email = useSelector((state) => state.service.email);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('error');
    const [resetingPw, setResetingPw] = useState(false);

    const handlePwSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword || !oldPassword || !confirmPassword) {
            setError('Заполните все поля');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Пароли не совпадают');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch('/Account/ChangePassword', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ oldPassword, newPassword }),
            });
            const data = await response.json();

            if (data.success) {
                setIsEditingPw(false);
                setAlertMessage('Пароль успешно изменён');
                setAlertType('success');
                setAlertVisible(true);
                setTimeout(() => setAlertVisible(false), 3000);
            } else {
                setError(data.message || 'Произошла ошибка');
            }
        } catch (err) {
            setError('Ошибка сети');
        }

        setLoading(false);
    };

    return (
        <div className="account-panel">
            {alertVisible && <Alert message={alertMessage} type={alertType} onClose={() => setAlertVisible(false)} />}

            <div className="account-panel__header">
                <div>
                    <h3 className="account-panel__title">Пароль</h3>
                    <p className="account-panel__subtitle">Обновляйте пароль и восстанавливайте доступ при необходимости.</p>
                </div>
            </div>

            {isEditingPw ? (
                resetingPw ? (
                    <div className="account-stack">
                        <ResetPwForm
                            emailInitialValue={email}
                            emailInputIsVisable={false}
                            onSuccess={() => {
                                setIsEditingPw(false);
                                setResetingPw(false);
                            }}
                        />
                        <div className="account-actions">
                            <button onClick={() => setResetingPw(false)} className="account-button--ghost" type="button">
                                Отмена
                            </button>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handlePwSubmit} className="account-form">
                        <div className="account-field">
                            <label className="account-field__label" htmlFor="account-old-password">
                                Старый пароль
                            </label>
                            <div className="account-confirmation__row">
                                <input
                                    id="account-old-password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Старый пароль"
                                    className="account-input"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="account-button--ghost"
                                >
                                    {showPassword ? <EyeOffIcon size={16} /> : <EyeIcon size={16} />}
                                </button>
                            </div>
                        </div>

                        <div className="account-field">
                            <label className="account-field__label" htmlFor="account-new-password">
                                Новый пароль
                            </label>
                            <div className="account-confirmation__row">
                                <input
                                    id="account-new-password"
                                    type={showNewPassword ? 'text' : 'password'}
                                    placeholder="Новый пароль"
                                    className="account-input"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    className="account-button--ghost"
                                >
                                    {showNewPassword ? <EyeOffIcon size={16} /> : <EyeIcon size={16} />}
                                </button>
                            </div>
                        </div>

                        <div className="account-field">
                            <label className="account-field__label" htmlFor="account-confirm-password">
                                Подтвердите пароль
                            </label>
                            <div className="account-confirmation__row">
                                <input
                                    id="account-confirm-password"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    placeholder="Подтвердите пароль"
                                    className="account-input"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    className="account-button--ghost"
                                >
                                    {showConfirmPassword ? <EyeOffIcon size={16} /> : <EyeIcon size={16} />}
                                </button>
                            </div>
                        </div>

                        {error &&
                            error.split('\n').map((err, index) => (
                                <p key={index} className="account-error">
                                    {err}
                                </p>
                            ))}

                        <button onClick={() => setResetingPw(true)} className="account-button--text" type="button">
                            Забыли пароль?
                        </button>

                        <div className="account-actions">
                            <button type="submit" disabled={loading} className="account-button">
                                {loading ? 'Загрузка...' : 'Сохранить'}
                            </button>
                            <button onClick={() => setIsEditingPw(false)} className="account-button--ghost" type="button">
                                Отмена
                            </button>
                        </div>
                    </form>
                )
            ) : (
                <div className="account-stack">
                    <div className="account-meta-row">
                        <span className="account-meta-label">Пароль</span>
                        <span className="account-meta-value">{'*'.repeat(8)}</span>
                    </div>
                    <div className="account-actions">
                        <button
                            onClick={() => {
                                setAllEditing(false);
                                setIsEditingPw(true);
                            }}
                            className="account-button--ghost"
                            type="button"
                        >
                            Изменить пароль
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PasswordEditForm;
